import { PipelineDetailsDto } from "@cradua/data";
import { createAction, props } from "@ngrx/store";

/**
 * Load Pipelinedetails Collection Actions
 */
export const loadPipelinedetails = createAction("[Pipelinedetails] Load Pipelinedetails");

export const loadPipelinedetailsSuccess = createAction(
  "[Pipelinedetails] Load Pipelinedetails Success",
  props<{ Pipelinedetails: PipelineDetailsDto[] }>(),
);

export const loadPipelinedetailsFailure = createAction(
  "[Pipelinedetails] Load Pipelinedetails Failure",
  props<{ error: any }>(),
);

/**
 * Add Pipelinedetails to Collection Actions
 */
export const addPipelinedetails = createAction(
  "[Pipelinedetails] Add Pipelinedetails",
  props<{
    newPipelinedetails: PipelineDetailsDto;
  }>(),
);

export const addPipelinedetailsSuccess = createAction(
  "[Pipelinedetails] Add Pipelinedetails Success",
  props<{ newPipelinedetails: PipelineDetailsDto }>(),
);

export const addPipelinedetailsFailure = createAction(
  "[Pipelinedetails] Add Pipelinedetails Failure",
  props<{ error: any }>(),
);

/**
 * Update Pipelinedetails Collection Actions
 */
export const updatePipelinedetails = createAction(
  "[Pipelinedetails] Update Pipelinedetails",
  props<{ updatePipelinedetails: PipelineDetailsDto }>(),
);

export const updatePipelinedetailsSuccess = createAction(
  "[Pipelinedetails] Update Pipelinedetails Success",
  props<{ updatePipelinedetails: PipelineDetailsDto }>(),
);

export const updatePipelinedetailsFailure = createAction(
  "[Pipelinedetails] Update Pipelinedetails Failure",
  props<{ error: any }>(),
);

/**
 * Fetch Pipelinedetails-record Collection Actions
 */
export const fetchPipelinedetailsRecord = createAction(
  "[Pipelinedetails-record] Fetch Pipelinedetails Record",
  props<{ fetch: any }>(),
);

export const fetchPipelinedetailsRecordSuccess = createAction(
  "[Pipelinedetails-record] Fetch Pipelinedetails Record Success",
  props<{ record: PipelineDetailsDto[] }>(),
);

export const fetchPipelinedetailsRecordFailure = createAction(
  "[Pipelinedetails-record] Fetch Pipelinedetails Record Failure",
  props<{ error: any }>(),
);

/**
 * Search for record Collection Actions
 */
export const searchPipelinedetailsRecord = createAction(
  "[Pipelinedetails] Search  Pipelinedetails Record",
  props<{ query: string }>(),
);

/**
 * Search for record Collection Actions
 */
export const searchPipelinedetailsIdRecord = createAction(
  "[Pipelinedetails] Search  Pipelinedetails Id Record",
  props<{ query: string }>(),
);

/**
 * Remove Pipelinedetails Collection Actions
 */
export const removePipelinedetails = createAction(
  "[Pipelinedetails] Remove Pipelinedetails",
  props<{ id: string }>(),
);

export const removePipelinedetailsSuccess = createAction(
  "[Pipelinedetails] Remove Pipelinedetails Success",
  props<{ id: string }>(),
);

export const removePipelinedetailsFailure = createAction(
  "[Pipelinedetails] Remove Pipelinedetails Failure",
  props<{ error: any }>(),
);



/**
 * Fetch Pipelinedetails-record By Id Collection Actions
 */
export const fetchByIdPipelinedetailsRecord = createAction(
  "[Pipelinedetails-record] Fetch Pipelinedetails Record By Id",
  props<{ id: string }>(),
);

export const fetchByIdPipelinedetailsRecordSuccess = createAction(
  "[Pipelinedetails-record] Fetch Pipelinedetails Record By Id Success",
  props<{ record: PipelineDetailsDto[] }>(),
);

export const fetchByIdPipelinedetailsRecordFailure = createAction(
  "[Pipelinedetails-record] Fetch Pipelinedetails Record By Id Failure",
  props<{ error: any }>(),
);



export const clearPipelinedetails = createAction("[Pipelinedetails] Clear Pipelinedetails");

export const clearPipelinedetailsSuccess = createAction(
  "[Pipelinedetails] Clear Pipelinedetails Success",
  props<{ Pipelinedetails: PipelineDetailsDto[] }>(),
);